(() => {
  angular
    .module('gm.common.analytics')
    .directive('gmyTrackClick', gmyTrackClick);

  function gmyTrackClick(
    $window,
    GmyGtm
  ) {
    'ngInject';

    return {
      link,
      restrict: 'A',
    };

    function link(scope, element, attrs) {
      function onClickHandler() {
        const value = attrs.btgTrack || attrs.id;
        const locationHash = $window.location.hash;

        if (!angular.isUndefined(value) && value.length > 0) {
          GmyGtm.push({
            pageName: `${locationHash}/[vpv/button-click/${value}]`,
            event: 'sendVirtualPage'
          });
        }
      }

      function onDestroy() {
        element.off('click', onClickHandler);
      }

      element.on('click', onClickHandler);
      scope.$on('$destroy', onDestroy);
    }
  }
})();
